import { action, computed, makeObservable, observable } from 'mobx';
import {X9ContentStateStore} from '../../common/X9ContentStateStore';
import {OpenEndedQuestionState} from './models';

export class OpenEndedQuestionStore {
  constructor(readonly id: number,
              readonly stateStore: X9ContentStateStore) {
    makeObservable(this);
  }
  
  @computed
  get state(): OpenEndedQuestionState {
    const altOpenEndedQuestionState: OpenEndedQuestionState = { answer: '' };
    return this.stateStore.getContentState<OpenEndedQuestionState>(this.id) ? this.stateStore.getContentState<OpenEndedQuestionState>(this.id)! : altOpenEndedQuestionState;
  }

  @action
  updateAnswer(answer: string) {
    this.updateState({ answer });
  }

  @action
  private updateState(state: OpenEndedQuestionState) {
    this.stateStore.setContentState<OpenEndedQuestionState>(this.id, state);
  }
}
